const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAssetByName = async (assetName) => {
  const token = localStorage.getItem('token');

  if (!token) {

    console.error('[getAssetByName] Ошибка: Токен авторизации не найден.');
    throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}/common/trade/assets/${assetName}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {

      const errorData = await response.json();
      console.error(`[getAssetByName] Ошибка получения актива ${assetName}:`, errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {

    console.error(`[getAssetByName] Ошибка сети или другая ошибка при получении актива ${assetName}:`, error);
    throw error;
  }
};